import { gettext } from '@adjust/dashboard-core/lib/utils/localization';
import { UserDetailScreen } from '@react/Pages/AccountSettingsPage/UserDetails/UserDetails/types';

const titles = {
  [UserDetailScreen.MAIN]: gettext('users.edit-user-details.title'),
  [UserDetailScreen.EMAIL]: gettext('label.change-email'),
  [UserDetailScreen.PASSWORD]: gettext('label.change-password'),
  [UserDetailScreen.API_TOKEN]: gettext('label.reset-api-token'),
};

export function getScreenTitle(screen: UserDetailScreen): string {
  return t(titles[screen]);
}
